import React from "react";

export default function Examples(props) {
    if (props.example) {
    return (
      <div className="Examples">
        <div><em>{props.example}</em></div>
      </div>
    );
  } else {
    return null;
  }
}